import React, {Component} from 'react';
import Alert from 'react-s-alert'
import PropTypes from "prop-types";

class PopUp extends Component {

    static propTypes = {
        /** Popup title/question */
        title: PropTypes.string,
        /** text displayed in accept button */
        acceptButtonText: PropTypes.string,
        /** text displayed in cancel button */
        cancelButtonText: PropTypes.string,
        /** Call function on accept click */
        onAccept: PropTypes.func,
        /** Call function on cancel click */
        onCancel: PropTypes.func
    };

    static defaultProps = {
        title: "Mottagningsbekräfta?",
        acceptButtonText: "Ja",
        cancelButtonText: "Nej",
        showButtons: true
    };

    constructor(props) {
        super(props);
        this.handleKeyPress = this.handleKeyPress.bind(this)
    }

    onAccept(event) {

        if (typeof(this.props.onAccept) === "function") {
            this.props.onAccept(event, this.props.id, this.props.object);
        }
        Alert.closeAll()

    }

    onCancel(event) {
        if (typeof(this.props.onCancel) === "function") {
            this.props.onCancel(event, this.props.id, this.props.object);
        }
        Alert.closeAll()
    }

    popupClick(e) {
        e.stopPropagation();
        e.preventDefault();
    }


    handleKeyPress(e) {
        if (e.keyCode === 27) {
            this.onCancel(e);
            e.preventDefault();
            e.stopPropagation();
        }

        if (e.keyCode === 13) {
            this.onAccept(e);
            e.preventDefault();
            e.stopPropagation();
        }
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyPress, false);
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyPress, false);
    }


    render() {
        const {title, acceptButtonText, cancelButtonText, showButtons} = this.props;
        return (
            <div className='popup verify confirm' onKeyPress={(e) => this.handleKeyPress(e)}>
                <div className='popup_inner verify'>
                    <button className='close' onClick={(event) => this.onCancel(event)}></button>

                    {title &&
                    <h1>{title}</h1>
                    }

                    {this.props.children &&
                    <div className={"content"}>
                        {this.props.children}
                    </div>
                    }

                    {showButtons &&
                    <div>
                        <button className='btn yellow'
                                onClick={(event) => this.onAccept(event)}>{acceptButtonText}</button>
                        <button className='btn white'
                                onClick={(event) => this.onCancel(event)}>{cancelButtonText}</button>
                    </div>
                    }

                </div>
            </div>
        );
    }
}

export default PopUp


// WEBPACK FOOTER //
// ./src/components/UI_Elements/Forms/PopUp.js